import { render, staticRenderFns } from "./BonusTargetBanner.vue?vue&type=template&id=1a847750&scoped=true"
import script from "./BonusTargetBanner.vue?vue&type=script&lang=js"
export * from "./BonusTargetBanner.vue?vue&type=script&lang=js"
import style0 from "./BonusTargetBanner.vue?vue&type=style&index=0&id=1a847750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a847750",
  null
  
)

export default component.exports